import { render } from "./packageView.vue?vue&type=template&id=aeef5a1e&scoped=true"
import script from "./packageView.vue?vue&type=script&lang=js"
export * from "./packageView.vue?vue&type=script&lang=js"

import "./packageView.vue?vue&type=style&index=0&id=aeef5a1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeef5a1e"]])

export default __exports__